<div class="settings-modal-content">
  <h2 class="mat-h2">Add region Files</h2>
  <div *ngIf="getRegions().length > 0">

    <div *ngFor="let region of getRegions()">
      <h3 class="my-3">{{ region.name }}</h3>
      <div class="flex">
        <p><strong>Pharmacy data:</strong>
          <span *ngIf="getRegionFiles(region.id).pharmacyDataUrl">&nbsp;<a [href]="getRegionFiles(region.id).pharmacyDataUrl" target="_blank">Download file</a></span>
          <span *ngIf="!getRegionFiles(region.id).pharmacyDataUrl"> No file uploaded</span>
        </p>
        <button *ngIf="!getRegionFiles(region.id).pharmacyDataUrl" mat-flat-button color="primary" (click)="filePharmacy.click()"><span>Add file</span></button>
        <button *ngIf="getRegionFiles(region.id).pharmacyDataUrl" mat-flat-button color="primary" (click)="deleteFile('pharmacy', region.id, getRegionFiles(region.id).pharmacyDataUrl)"><span>Delete file</span></button>
        <input hidden (change)="addFile('pharmacy', region.id, $event)" #filePharmacy type="file" id="filePharmacy" />
      </div>
      <mat-divider></mat-divider>
      <div class="flex">
        <p><strong>Brick data:</strong>
          <span *ngIf="getRegionFiles(region.id).brickDataUrl">&nbsp;<a [href]="getRegionFiles(region.id).brickDataUrl" target="_blank">Download file</a></span>
          <span *ngIf="!getRegionFiles(region.id).brickDataUrl"> No file uploaded</span>
        </p>
        <button *ngIf="!getRegionFiles(region.id).brickDataUrl" mat-flat-button color="primary" (click)="fileBrick.click()"><span>Add file</span></button>
        <button *ngIf="getRegionFiles(region.id).brickDataUrl" mat-flat-button color="primary" (click)="deleteFile('brick', region.id, getRegionFiles(region.id).brickDataUrl)"><span>Delete file</span></button>
        <input hidden (change)="addFile('brick', region.id, $event)" #fileBrick type="file" id="fileBrick" />
      </div>
      <mat-divider></mat-divider>
    </div>

  </div>
</div>
